import BOSTools from 'BOSTools/components/BOSTools';
import GrandfatheringData from 'BOSTools/components/GrandfatheringData';
import {useBreadcrumbs} from 'Core/hooks/useBreadcrumbs';
import * as E from 'fp-ts/lib/Either';
import {pipe} from 'fp-ts/lib/pipeable';
import React from 'react';
import {useSelector} from 'react-redux';
import {Redirect, Route, Switch} from 'react-router-dom';
import Loading from 'Shared/components/Loading';
import {Scope} from 'Shared/constants/Scope';
import {selectUserScopesEither} from 'Users/selectors/userProfileSelectors';

const ROOT_URI = '/bostools';
export const BOSToolsRouteConstants = {
  BOSTOOLS: ROOT_URI,
  GRANDFATHERING_DATA: `${ROOT_URI}/grandfatheringdata`,
};

const BOSToolsRoutes = () => {
  const currentScopesEither = useSelector(selectUserScopesEither);
  useBreadcrumbs('BOS Tools', BOSToolsRouteConstants.BOSTOOLS);

  const renderBOSTools = (currentScopes: Scope[]) => {
    const canAccessBOSTools = currentScopes.includes(Scope.BOSTools);

    return canAccessBOSTools ? (
      <Route
        render={({match}) => (
          <Switch>
            <Route exact path={BOSToolsRouteConstants.BOSTOOLS} render={() => <BOSTools />} />
            <Route exact path={BOSToolsRouteConstants.GRANDFATHERING_DATA} render={() => <GrandfatheringData />} />
          </Switch>
        )}
      />
    ) : (
      <Redirect to={'/unauthorized'} />
    );
  };

  return (
    <Route
      path={ROOT_URI}
      render={() =>
        pipe(
          currentScopesEither,
          E.fold(() => <Loading />, renderBOSTools)
        )
      }
    />
  );
};

export default () => <Route path={ROOT_URI} render={() => <BOSToolsRoutes />} />;
